import { memo } from "react";

/**
 * Mockup-style shell nav item (hrms-ui / Attendance actions redesign).
 * Admin (horizontal): icon only; active = icon + label pill.
 * ESS (vertical): icon + caption; active uses employee accent.
 * No flip animation — routes/handlers stay with the parent.
 */
function ShellIconNavItem({
  icon: Icon,
  label,
  title,
  active = false,
  disabled = false,
  orientation = "horizontal",
  /** "admin" = teal accent; "ess" = purple employee rail */
  tone = "admin",
  badge = null,
  onClick,
  className = "",
  buttonRef = null,
}) {
  const tip = String(title || label || "").trim();
  const badgeText =
    badge == null || badge === "" || Number(badge) <= 0
      ? null
      : Number(badge) > 10
        ? "10.."
        : String(badge);

  const vertical = orientation === "vertical";
  const ess = tone === "ess";

  return (
    <button
      ref={buttonRef}
      type="button"
      disabled={disabled}
      title={tip || undefined}
      aria-label={
        badgeText ? `${tip || label}, ${badgeText} pending` : tip || label
      }
      aria-current={active ? "page" : undefined}
      onClick={onClick}
      className={`shell-icon-nav ${
        vertical ? "shell-icon-nav--vert" : "shell-icon-nav--horiz"
      } ${ess ? "shell-icon-nav--ess" : "shell-icon-nav--admin"} ${
        active ? "is-active" : ""
      } ${disabled ? "is-disabled" : ""} ${className}`.trim()}
    >
      <span className="shell-icon-nav-inner">
        {Icon && typeof Icon !== "string" ? (
          <Icon
            size={20}
            strokeWidth={1.7}
            className="shell-icon-nav-svg"
            aria-hidden
          />
        ) : null}
        {vertical || active ? (
          <span className="shell-icon-nav-label">{label}</span>
        ) : null}
      </span>
      {badgeText ? (
        <span className="shell-icon-nav-badge" aria-hidden>
          {badgeText}
        </span>
      ) : null}
    </button>
  );
}

export default memo(ShellIconNavItem);
